// Sample card from Airbnb
import React from "react";
import { Link } from "react-router-dom"
// import Button from "../components/Button"
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert';
import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Form from "react-validation/build/form";
import ReactLoading from "react-loading";
import "react-datepicker/dist/react-datepicker.css";
import APIConfig from "../../../../api/APIConfig";

import {
    Box,
    Center,
    Button,
    Stack,
    Text,
    VStack,
    HStack,
    FormControl,
    FormLabel,
    Input,
    Textarea,
} from '@chakra-ui/react';

function EditLaporan() {
    const navigate = useNavigate();
    const [topik, setTopik] = useState('');
    const [bulan, setBulan] = useState();
    const [minggu, setMinggu] = useState();
    const [isiLaporan, setIsiLaporan] = useState('');
    const [spinner, setSpinner] = useState(false);
    const { id } = useParams();
    const { idPeserta } = useParams();
    const optionBulan = [
        { value: 1, label: "Januari" },
        { value: 2, label: "Februari" },
        { value: 3, label: "Maret" },
        { value: 4, label: "April" },
        { value: 5, label: "Mei" },
        { value: 6, label: "Juni" },
        { value: 7, label: "Juli" },
        { value: 8, label: "Agustus" },
        { value: 9, label: "September" },
        { value: 10, label: "Oktober" },
        { value: 11, label: "November" },
        { value: 12, label: "Desember" },
    ]
    const optionMinggu = [
        { value: 1, label: "Minggu ke-1" },
        { value: 2, label: "Minggu ke-2" },
        { value: 3, label: "Minggu ke-3" },
        { value: 4, label: "Minggu ke-4" },
    ]

    useEffect(() => {
        getLaporanByIdLaporan();
        
    }, []);

    const getLaporanByIdLaporan = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/laporan/${id}`);
        const data = await response.data
        setTopik(data.topik);
        setBulan(data.bulan);
        setMinggu(data.minggu);
        setIsiLaporan(data.isiLaporan);
        setSpinner(false);
    };

    const updateLaporan = async (e) => {
        e.preventDefault();
        swal("Apakah Anda yakin ingin memperbarui laporan?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`/v1/laporan/${id}`, {
                    topik: topik,
                    bulan: bulan,
                    minggu: minggu,
                    isiLaporan : isiLaporan,
                })
                .then(() => {
                    console.log("berhasil") 
                    navigate(`/peserta/kegiatanku/kegiatanaktif/${idPeserta}`);
                    swal({
                        title: "Kamu berhasil memperbarui laporan!",
                        icon: "success",
                        button: "OK",
                      });
        
                })
                .catch((error) => {
                    console.log(error);
                })
            }
            return false;
        });
    };

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }
    
    return (
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                fontFamily={'Inter'}>
                Edit Laporan
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to={`/peserta/kegiatanku/kegiatanaktif/${idPeserta}`}> Kegiatan Aktif</Link>
                <p> / </p>
                <Link to=""> Edit Laporan</Link>
            </HStack>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >   
                    <Form p={6} onSubmit={updateLaporan}>
                       
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='bulan'>Bulan</FormLabel>
                                <Select
                                    style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                    id='bulan' 
                                    options={optionBulan}
                                    onChange={(e) =>  setBulan(e.value)}
                                    value={optionBulan.find((obj) => obj.value === bulan)}
                                placeholder="-- Pilih Bulan --" />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='minggu'>Minggu</FormLabel>
                                <Select
                                    style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                                    id='minggu' 
                                    options={optionMinggu}
                                    onChange={(e) =>  setMinggu(e.value)}
                                    value={optionMinggu.find((obj) => obj.value === minggu)}
                                placeholder="-- Pilih Minggu --" />
                        </FormControl>
                       
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='topik'>Topik</FormLabel>
                        <Input 
                        id='topik' 
                        placeholder='Masukkan topik pembelajaran'
                        value={topik}
                        onChange={(e) => setTopik(e.target.value)} 
                        />
                        </FormControl>


                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='isiLaporan'>Laporan</FormLabel>
                        <Textarea 
                        type='text'
                        id='isiLaporan' 
                        placeholder='Tulis laporan kegiatan'
                        value={isiLaporan}
                        onChange={(e) => setIsiLaporan(e.target.value)}
                        />
                        </FormControl>
                        
                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Kirim
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default EditLaporan;